export function formatCurrency(
  amount: string | number,
  currency: string = 'usd',
  locale: string = 'en-US',
): string {
  const numericAmount
    = typeof amount === 'string' ? Number.parseFloat(amount) : Number(amount);

  if (!Number.isFinite(numericAmount)) {
    return typeof amount === 'string' ? amount : numericAmount.toString();
  }

  const normalizedCurrency = currency ? currency.toUpperCase() : 'USD';

  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: normalizedCurrency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(numericAmount);
  }
  catch {
    const prefix = normalizedCurrency === 'USD' ? '$' : '';
    return `${prefix}${numericAmount.toFixed(2)}`;
  }
}
